export const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || ''
export const ENTRY_POINT = BASE_URL + process.env.NEXT_PUBLIC_API_ENTRYPOINT
